import { render, staticRenderFns } from "./RecommendedItems.vue?vue&type=template&id=bbb8faea&scoped=true"
import script from "./RecommendedItems.vue?vue&type=script&lang=js"
export * from "./RecommendedItems.vue?vue&type=script&lang=js"
import style0 from "./RecommendedItems.vue?vue&type=style&index=0&id=bbb8faea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb8faea",
  null
  
)

export default component.exports